import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"label":_vm.$t('Locations'),"outlined":"","item-text":"label","item-value":"code","return-object":false,"items":_vm.locations,"loading":_vm.loading,"hide-details":"auto","clearable":""},model:{value:(_vm.zoneCode),callback:function ($$v) {_vm.zoneCode=$$v},expression:"zoneCode"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }